<template>
  <div class="a4">
    <!-- 안전인력 운용현황 -->
    <div style="margin-bottom: 40px;">
      <div class="bullseye none-colon" style="width: 228px; margin-bottom: 14px; text-align-last: justify;">안전인력 운용현황</div>
      <div style="margin-bottom: 24px;">
        <p class="header26" style="margin-bottom: 14px; padding-left: 24px">- 안전인력 총괄</p>
        <table class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <colgroup>
            <col width="145px"/>
            <col width="261px"/>
            <col width="144px"/>
            <col width="476px"/>
          </colgroup>
          <thead>
          <tr class="border-center" style="border-bottom: 6px double #757575;">
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">확보인원</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">주요업무</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">추가필요인력</div></th>
            <th><div style="padding: 5px 10px; text-align: center;">사유 및 추가확보 계획</div></th>
          </tr>
          </thead>
          <tbody>
          <tr class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.안전인력_운용현황.cell1 || '-'}}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.안전인력_운용현황.cell2 || '-'}}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.안전인력_운용현황.cell3 || '-'}}</div></td>
            <td><div style="padding: 5px 10px;">{{ value.안전인력_운용현황.cell4 || '-'}}</div></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="margin-bottom: 24px;">
        <p class="header26" style="margin-bottom: 14px; padding-left: 24px">- 업무분장 반영 여부</p>
        <div style="display: grid; font-size: 26px;">
          <print-radio style="gap: 12px !important;" label="업무분장 반영" :value="value.업무분장_반영여부 === '업무분장 반영'">
            <template #onIcon>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="20" height="20" rx="10" fill="#696D71"/>
                <circle cx="10" cy="10" r="3.75" fill="white"/>
              </svg>
            </template>
            <template #offIcon>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#B4B4B4"/>
              </svg>
            </template>
          </print-radio>
          <div class="flex gap-2 items-center">
            <print-radio style="gap: 12px !important;" label="업무분장 미 반영" :value="value.업무분장_반영여부 === '업무분장 미 반영'" >
              <template #onIcon>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="20" height="20" rx="10" fill="#696D71"/>
                  <circle cx="10" cy="10" r="3.75" fill="white"/>
                </svg>
              </template>
              <template #offIcon>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#B4B4B4"/>
                </svg>
              </template>
            </print-radio>
            {{ value.업무분장_반영여부_input ? `( ${value.업무분장_반영여부_input} )` : ''}}
            <span>※(예시)00월까지 반영</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 안전점검 및 보수보강 등 유지관리 현황-->
    <div style="margin-bottom: 40px;">
      <div style="display: flex; align-items: center; margin-bottom: 14px;">
        <div class="bullseye none-colon" style="width: 450px; text-align-last: justify;">안전점검 및 보수보강 등 유지관리 현황</div>
        <span class="text-hint" style="margin-left: 10px; font-size: 22px;">※ 관계법령상 모든 안전점검기재</span>
      </div>
      <div style="margin-bottom: 24px;">
        <p class="header26" style="margin-bottom: 14px; padding-left: 24px">- 정기점검</p>
        <table class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <colgroup>
            <col width="228px"/>
            <col width="192px"/>
            <col width="150px"/>
            <col width="228px"/>
            <col width="228px"/>
          </colgroup>
          <thead>
          <tr class="border-center" style="border-bottom: 6px double #757575;">
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">관련법령</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">분야</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">점검<br>(예정)일자</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">점검내용</div></th>
            <th><div style="padding: 5px 10px; text-align: center;">점검방법</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="data in value.유지관리_현황_정기점검" class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 15px 10px; font-size: 19px; border-right: 1px solid #757575;">{{ data.cell1 || '-'}}</div></td>
            <td><div style="padding: 15px 10px; font-size: 19px; border-right: 1px solid #757575;">{{ data.cell2 || '-'}}</div></td>
            <td><div style="padding: 15px 10px; font-size: 19px; border-right: 1px solid #757575;">{{ data.cell3 || '-'}}</div></td>
            <td><div style="padding: 15px 10px; font-size: 19px; border-right: 1px solid #757575;">{{ data.cell4 || '-'}}</div></td>
            <td><div style="padding: 15px 10px; font-size: 19px;">{{ data.cell5 || '-'}}</div></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div>
        <p class="header26" style="margin-bottom: 14px; padding-left: 24px">- 수시점검(유지관리)</p>
        <table class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <colgroup>
            <col width="327px"/>
            <col width="221px"/>
            <col width="150px"/>
            <col width="327px"/>
          </colgroup>
          <thead>
          <tr class="border-center" style="border-bottom: 6px double #757575;">
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">관련법령</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">분야</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">주기</div></th>
            <th><div style="padding: 5px 10px; text-align: center;">유지관리사항</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="data in value.유지관리_현황_수시점검" class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell1 || '-' }}</div></td>
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell2 || '-' }}</div></td>
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell3 || '-' }}</div></td>
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell4 || '-' }}</div></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 주요 유해위험 요인 발생 및 조치현황-->
    <div style="margin-bottom: 40px;">
      <div style="display: flex; align-items: center; margin-bottom: 14px;">
        <div class="bullseye none-colon" style="width: 425px; text-align-last: justify;">주요 유해위험 요인 발생 및 조치현황</div>
      </div>
      <div style="margin-bottom: 24px;">
        <table v-for="data in value.주요유해위험요인발생및조치현황" class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <colgroup>
            <col width="262px"/>
            <col width="165px"/>
            <col width="463px"/>
            <col width="136px"/>
          </colgroup>
          <thead>
          <tr class="border-center" style="border-bottom: 6px double #757575;">
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">발생현황</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">확인경위</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">조치사항</div></th>
            <th><div style="padding: 5px 10px; text-align: center;">보고<br>(시장)</div></th>
          </tr>
          </thead>
          <tbody>
          <tr class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell1 || "-"}}</div></td>
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell2 || "-"}}</div></td>
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell3 || "-"}}</div></td>
            <td><div style="padding: 15px 10px;">{{ data.cell4 || "-"}}</div></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 비상대피훈련 실시-->
    <div style="margin-bottom: 40px;">
      <div style="display: flex; align-items: center; margin-bottom: 14px;">
        <div class="bullseye none-colon" style="width: 230px; text-align-last: justify;">비상대피훈련 실시</div>
        <span class="text-hint" style="margin-left: 10px; font-size: 22px;">※ 1종 시설에 해당됨</span>
      </div>
      <div>
        <table v-for="data in value.비상대피훈련실시" class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <colgroup>
            <col width="417px"/>
            <col width="192px"/>
            <col width="417px"/>
          </colgroup>
          <thead>
          <tr class="border-center" style="border-bottom: 6px double #757575;">
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center; ">대상법령</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">시행여부</div></th>
            <th><div style="padding: 5px 10px; text-align: center;">조치계획</div></th>
          </tr>
          </thead>
          <tbody>
          <tr class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell1 || "-"}}</div></td>
            <td><div style="padding: 15px 10px; border-right: 1px solid #757575;">{{ data.cell2 || "-"}}</div></td>
            <td><div style="padding: 15px 10px;">{{ data.cell3 || "-"}}</div></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import PrintRadio from "@/components/print/PrintRadio.vue";
import Template from "@/views/boards/single-page/1044/print/Template.vue";

export default {
  components: {Template, PrintRadio},
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
  },
  methods: {
  }
}
</script>
